import {
    GRID_MOUNT,
    GRID_PROPERTIES_LOADED,
    GRID_HEADER_SHOW_OPTIONS,
    GRID_HEADER_OPTION_LABEL_CHANGED,
    GRID_BULK_OPEN,
    GRID_BULK_ACTION_OPEN,
    GRID_QUICK_FILTER_CHANGE,
    GRID_DATES_CHANGE,
    GRID_HEADER_OPTION_SELECTED,
    GRID_COLUMNS_SHOW,
    GRID_COLUMNS_CHECK,
    GRID_COLUMNS_UPDATE,
    GRID_CONFIRM_DIALOG_SHOW,
    GRID_ROWS_SELECTED,
    GRID_HEADER_SHOW_LOADER,
    GRID_VIEW_DIALOG_OPEN,
    GRID_VIEW_DIALOG_CONTENT
} from "../constants/actionTypes";


export default (state = [], action) => {
    let header = null;
    let columns = [];
    let bulkActions = state.bulkActions;

    switch (action.type) {
        case GRID_MOUNT:
            return {
                ...state,
                gridRoute: action.payload.gridRoute,
                gridDataRoute: action.payload.gridDataRoute
            };

        case GRID_PROPERTIES_LOADED:
            return {
                ...state,
                columns: action.payload.columns,
                visibleColumns: action.payload.visibleColumns,
                bulkActions: action.payload.bulkActions,
                header: action.payload.header,
                options: action.payload.options,
                pinnedRows: action.payload.pinnedRows
            };

        case GRID_ROWS_SELECTED:
            return {
                ...state,
                selectedRowsCount: action.payload.rows
            };

        case GRID_HEADER_OPTION_SELECTED:
            let filters = action.payload.option.filters;
            if (!filters) return state;
            filters.forEach(filter => {
                if (action.payload.gridApi.gridCore.columnApi.getColumn(filter.column)) {
                    let f = action.payload.gridApi.getFilterInstance(filter.column);
                    f.setModel({
                        type: filter.type,
                        filter: filter.value,
                        filterTo: null
                    });
                }
            });
            return state;

        case GRID_HEADER_SHOW_OPTIONS:
            header = state.header;
            header.showOptions = 'showOptions' in header ? !header.showOptions : true;
            return {
                ...state,
                header
            };

        case GRID_HEADER_OPTION_LABEL_CHANGED:
            header = state.header;
            header.selectedFilter = action.payload.option.label;
            return {
                ...state,
                header
            };

        case GRID_BULK_OPEN:
            bulkActions.forEach((bulk, key) => {
                if (bulk.label === action.payload.bulk.label) {
                    bulkActions[key].showDropdown = 'showDropdown' in bulkActions[key] ? !bulkActions[key].showDropdown : true;
                    if (!bulkActions[key].showDropdown && 'actions' in bulk) {
                        bulk.actions.forEach((option, actionKey) => {
                            bulkActions[key].actions[actionKey].showDropdown = false;
                        });
                    }
                }
            });
            return {
                ...state,
                bulkActions
            };

        case GRID_BULK_ACTION_OPEN:
            bulkActions.forEach((bulk, key) => {
                if (bulk.label === action.payload.bulk.label) {
                    bulk.actions.forEach((option, actionKey) => {
                        if (option.label === action.payload.action.label) {
                            bulkActions[key].actions[actionKey].showDropdown = 'showDropdown' in bulkActions[key].actions[actionKey] ? !bulkActions[key].actions[actionKey].showDropdown : true;
                        }
                    })
                }
            });
            return {
                ...state,
                bulkActions
            };

        case GRID_QUICK_FILTER_CHANGE:
            return {
                ...state,
                quickFilter: action.payload.value
            };

        case GRID_DATES_CHANGE:
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
            };

        case GRID_COLUMNS_SHOW:
            return {
                ...state,
                showColumns: 'showColumns' in state ? !state.showColumns : true
            };

        case GRID_COLUMNS_CHECK:
            columns = state.columns;
            const key = action.payload.key;
            const childKey = action.payload.childKey;
            if (childKey) {
                const hideCol = 'hide' in columns[key]['children'][childKey] ? !columns[key]['children'][childKey] : true;
                columns[key]['children'][childKey].hide = hideCol;
            } else {
                const hide = 'hide' in columns[key] ? !columns[key].hide : true;
                columns[key].hide = hide;
                if ('children' in columns[key]) {
                    columns[key].children.map((child, k) => {
                        columns[key][k] = hide;
                    });
                }
            }
            return {
                ...state,
                columns
            };

        case GRID_COLUMNS_UPDATE:
            //make columns visible or not in grid
            columns = state.columns;
            columns.map(column => {
                //if has children itterate them and check
                if (column.children) {
                    column.children.map(child => {
                        if (!child.hide) {
                            action.payload.gridColumnApi.setColumnVisible(child.field, true);
                        } else {
                            action.payload.gridColumnApi.setColumnVisible(child.field, false);
                        }
                    })
                } else {
                    if (!column.hide) {
                        action.payload.gridColumnApi.setColumnVisible(column.field, true);
                    } else {
                        action.payload.gridColumnApi.setColumnVisible(column.field, false);
                    }
                }
            });
            return state;

        case GRID_CONFIRM_DIALOG_SHOW:
            let confirm = 'confirm' in state ? state['confirm'] : {};
            confirm = {
                show: 'show' in confirm ? !confirm['show'] : true,
                payload: action.payload
            };
            return {
                ...state,
                confirm
            };

        case GRID_HEADER_SHOW_LOADER:
            return {
                ...state,
                showLoader: action.payload
            };

        case GRID_VIEW_DIALOG_OPEN:
            return {
                ...state,
                openView: action.payload
            };

        case GRID_VIEW_DIALOG_CONTENT:
            return {
                ...state,
                contentView: action.payload
            };
        
        default:
            return state;
    }
};